import { Button, Divider, Modal, Popover } from 'antd';
import { EditOutlined, DownOutlined } from '@ant-design/icons';
import { COLORS } from '../constants/Colors';
import Typography from './Typography';
import { CustomerListItem } from './CustomerList';
import MyButton from './Button';
import React, { useState } from 'react';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import _ from 'lodash';
import './Customer.css';
import { FormattedMessage } from 'react-intl';

const CustomerProfileCard = (props) => {
  const { onClickEdit, customerData, onClickDelete } = props;
  const isDesktop = useIsDesktop();
  const [isOpen, setIsOpen] = useState(false);

  const PopoverContent = (
    <div style={{ width: '100%' }}>
      <div>
        <Button
          className='customer-button'
          style={{ width: '100%' }}
          type='text'
          onClick={() => {
            onClickEdit('edit');
          }}
        >
          <Typography><FormattedMessage id='btnEdit' defaultMessage='Edit' /></Typography>
        </Button>
        {/* <Typography>Edit</Typography> */}
      </div>
      <div>
        <Button
          className='customer-button'
          style={{ width: '100%' }}
          type='text'
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <Typography><FormattedMessage id="btnDelete" defaultMessage="Delete" /></Typography>
        </Button>
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        backgroundColor: 'white',
        width: '100%',
      }}
    >
      <Modal
        open={isOpen}
        onOk={() => {
          onClickDelete(customerData);
          setIsOpen(false);
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
        centered
        className='custom-modal'
        bodyStyle={{ overflow: 'hidden', height: '100px' }}
        style={{ marginTop: isDesktop ? '150px' : '150px', maxWidth: '350px', marginBottom: '150px' }}
      >
        <Typography isBold size='16px' color={COLORS.Primary} className='text-center p-2'>
        <FormattedMessage id="confirmModalDelete" defaultMessage="Confirm delete" />
        </Typography>
        <Typography className='text-center p-3'><FormattedMessage id="confirmDeleteCustomer" defaultMessage="Do you want to delete customer ?" /></Typography>
      </Modal>
      <div className='d-flex flex-column justify-content-center text-left w-100'>
        <div className='d-flex flex-row justify-content-between align-items-center w-100'>
          <Typography
            className='py-3 px-4'
            isBold
            color={COLORS.Primary}
          >
            <FormattedMessage id="titleCustomerProfile" defaultMessage="Customer Profile" />
          </Typography>

          <Popover content={PopoverContent} placement='bottomRight' trigger='hover'>
            <MyButton className='mx-4 my-3' isPrimary>
              <EditOutlined />
              {isDesktop && (
                <>
                  <FormattedMessage id="btnAction" defaultMessage="Action" />
                  <DownOutlined className='pl-2' />
                </>
              )}
            </MyButton>
          </Popover>
        </div>
        <Divider className='m-0' />
        <div className='py-3 px-4'>
          <CustomerListItem customer={customerData} isHideAction profile={true} />
        </div>
      </div>
    </div>
  );
};

export default CustomerProfileCard;
